import { HttpErrorResponse } from '@angular/common/http';
import { TAuthOrigin } from '@application/config';

export interface IAuthAccessToken {
  readonly Token: string;
  readonly Type: 'Bearer';
  readonly TenantSupportId: string;
  readonly TokenId: string;
  readonly PersonId: string;
  readonly TenantId: string;
  readonly SupportPersonId?: string | null;
  readonly SelectedByServer?: boolean;
}

export enum EAuthValidationKey {
  Access = 'Access',
  Refresh = 'Refresh',
  SimpleLogin = 'SimpleLogin',
}

export interface IAuthValidationError {
  readonly PropertyName: string;
  readonly ErrorMessage: string;
}

export const AUTH_INVALID_TOKEN_MESSAGE = 'Localize.UserService.Msg.InvalidToken';

const EMPTY_SUPPORT_PERSON_ID = '00000000-0000-0000-0000-000000000000';

export function isSupportSessionToken(authData: IAuthAccessToken | null): boolean {
  const supportPersonId = authData?.SupportPersonId;
  return !!supportPersonId && supportPersonId !== EMPTY_SUPPORT_PERSON_ID;
}

export function hasAuthValidationError(
  error: HttpErrorResponse,
  propertyName: EAuthValidationKey,
  errorMessage?: string
): boolean {
  const errors: IAuthValidationError[] =
    error?.status === 400 ? error.error?.ValidationResult?.Errors ?? [] : [];
  return errors.some(
    (item) =>
      item.PropertyName === propertyName &&
      (!errorMessage || item.ErrorMessage === errorMessage)
  );
}

export interface IAuthLoginPayload {
  Password: string;
  Email: string;
  /** Uma origem, ou a lista separada por vírgula que o backend divide. */
  Origin?: TAuthOrigin | 'ediz,edizapp';
}

export enum ELocalStorageKeys {
  auth = 'authorization',
  webauthn = 'credentials',
  rememberEmail = 'rememberEmail',
  allPersonsByUser = 'allPersonsByUser',
}

export type GetAllPersonsByUserResponse = {
  PersonId: string;
  UserId: string;
  FirstName: string;
  IsActive: boolean;
  IsOwner: boolean;
  AppSource: number;
  TenantId: string;
  TenantName: string;
  Email: string; //front end only
};
